import {
  UNIFIED_CUSTOMER_SERVICE_PHONE_NUMBER,
  URL_CONTACTUS,
} from '@seek/adv-constants';
import { useTranslations } from '@vocab/react';
import {
  Box,
  ContentBlock,
  Heading,
  Stack,
  Text,
  TextLink,
} from 'braid-design-system';
import { useEffect, useState } from 'react';

import { useConfig } from 'src/hooks/context';
import type { SecureLinkErrorType } from 'src/types';
import { getQueryParams } from 'src/utils/queryParams';
import { ErrorSVG } from 'src/views/shared/ErrorSVG/ErrorSVG';

import translations from './.vocab';

const SecureLinkErrorPage = () => {
  const [errorType, setErrorType] = useState<SecureLinkErrorType | undefined>();
  const { site, isAnz, absoluteEmployerUrlResolver } = useConfig();

  const { t } = useTranslations(translations);
  const contactCustomerServiceUrl = absoluteEmployerUrlResolver(URL_CONTACTUS);

  useEffect(() => {
    const { reason } = getQueryParams();
    setErrorType((reason as SecureLinkErrorType) || 'Invalid');
  }, []);

  const getErrorHeading = () => {
    switch (errorType) {
      case 'expired':
        return <Heading level="3">{t('This link has expired')}</Heading>;
      case 'used':
        return (
          <Heading level="3">{t('Your email address is verified')}</Heading>
        );
      default:
        return <Heading level="3">{t('This link isnt working')}</Heading>;
    }
  };

  return (
    <ContentBlock width="small">
      <Box paddingY={['none', 'xxlarge']}>
        <Box
          background="surface"
          paddingY={['xxlarge', 'xlarge']}
          paddingX="gutter"
        >
          <Stack space={['large', 'xlarge']} align="center">
            <ErrorSVG />
            <Box>
              <Stack space="gutter" align="center">
                {getErrorHeading()}
                <Text tone="secondary">
                  {t('Reach out Customer Service')} {t('Contact on')}{' '}
                  {isAnz ? (
                    <TextLink
                      href={`tel:${UNIFIED_CUSTOMER_SERVICE_PHONE_NUMBER[site]}`}
                    >
                      {UNIFIED_CUSTOMER_SERVICE_PHONE_NUMBER[site]}
                    </TextLink>
                  ) : (
                    <TextLink href={contactCustomerServiceUrl}>
                      {t('Contact Customer Service')}
                    </TextLink>
                  )}
                </Text>
              </Stack>
            </Box>
          </Stack>
        </Box>
      </Box>
    </ContentBlock>
  );
};

export default SecureLinkErrorPage;
